import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Dropdown, Input, Button } from 'wix-style-react'
import _ from 'lodash'

import Text from 'components/common/Text'
import Pagination from 'components/shared/Pagination'

const Container = styled.div`
  width: 100%;
  height: 10em;
  margin-top: 1em;
  _background-color: #CCCCCC;
`
const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
`
const Side = styled.div`
  display: flex;
  justify-content: space-between;
`
const ParamContainer = styled.div`
  margin-right: ${props => props.right ? props.right : '5em'};
  margin-left: ${props => props.left ? props.left : '0em'};
  width: ${props => props.width};
`

class Menu extends Component {

  constructor (props) {
    super(props)
    this.state = {
      searchString: ''
    }
  }

  renderNetworkInput () {
    const { app } = this.props
    const instaName = _.get(app, ['customFields', 'appSettings', 'instaName'])
    return (
      <ParamContainer width='20em' className='ltr'>
        <Text appearance='T3.1'>Filter by Network</Text>
        <Dropdown
          options={[{id: 1, value: instaName}]}
          selectedId={1}
          placeholder={'Choose an option'}
          onSelect={() => null}
          roundInput
        />
      </ParamContainer>
    )
  }

  onChangeFilterVisability = (v) => {
    this.props.onChangeFilterVisability(v.id)
  }

  renderVisabilityInput () {
    const options = [
      {id: 0, value: 'All Posts'},
      {id: 1, value: 'Visible Posts'},
      {id: 2, value: 'Hidden Posts'}
    ]
    return (
      <ParamContainer width='20em' className='ltr'>
        <Text appearance='T3.1'>Post Visibility</Text>
        <Dropdown
          options={options}
          selectedId={this.props.filterVisability}
          placeholder={'Choose an option'}
          onSelect={this.onChangeFilterVisability}
          roundInput
        />
      </ParamContainer>
    )
  }

  onSearchInputChange = (e) => {
    e.preventDefault()
    this.setState({searchString: e.target.value})
    this.props.onSearchStringChange(e.target.value)
  }
  onSearchInputClear = (e) => {
    e.preventDefault()
    this.setState({searchString: ''})
    this.props.onSearchStringChange('')
  }

  renderSearchInput () {
    return (
      <ParamContainer width='30em' right='0em'>
        <Text appearance='T3.1'>Search Captions</Text>
        <Input
          placeholder='Search Term'
          roundInput
          value={this.state.searchString}
          onChange={this.onSearchInputChange}
          onClear={this.onSearchInputClear}
        />
      </ParamContainer>
    )
  }

  renderPagination () {
    const { pagActivePage, pagItemsCountPerPage, pagItemsCount, pagOnPaginationChange } = this.props
    return (
      <Pagination
        activePage={pagActivePage}
        itemsCountPerPage={pagItemsCountPerPage}
        totalItemsCount={pagItemsCount}
        pageRangeDisplayed={5}
        onChange={pagOnPaginationChange}
      />
    )
  }

  render () {
    const { onGetNewPosts } = this.props
    return (
      <Container>
        <Row>
          <Side>
            {this.renderNetworkInput()}
            {this.renderVisabilityInput()}
          </Side>
          <Side>
            {this.renderSearchInput()}
          </Side>
        </Row>

        <Row>
          <Side>
            <Button onClick={onGetNewPosts}>Get New Posts</Button>
          </Side>
          <Side>
            {this.renderPagination()}
          </Side>
        </Row>
      </Container>
    )
  }
}

Menu.defaultProps = {
  filterVisability: 0,
  onChangeFilterVisability: () => null,
  onSearchStringChange: () => null,
  onGetNewPosts: () => null,
  pagActivePage: 1,
  pagItemsCountPerPage: 1,
  pagItemsCount: 0,
  pagOnPaginationChange: () => null
}

Menu.propTypes = {
  app: PropTypes.object.isRequired,
  filterVisability: PropTypes.number,
  onChangeFilterVisability: PropTypes.func,
  onSearchStringChange: PropTypes.func,
  onGetNewPosts: PropTypes.func,
  pagActivePage: PropTypes.number,
  pagItemsCountPerPage: PropTypes.number,
  pagItemsCount: PropTypes.number,
  pagOnPaginationChange: PropTypes.func
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/Menu.js